import DashboardAbsensi from "../../../../../components/categories/siakad/lms/dashboards_absensi/Home";
export default function Home() {
  
  return (
    <DashboardAbsensi />
  );
}
